<template>
<div>
  <b-container v-if="solicitud" fluid>
    <h1>Agregar Comentario</h1>
    <b-card bg-variant="light" :title="solicitud.PersonalString.toUpperCase()">
      <item-lista-solicitud :item="solicitud"></item-lista-solicitud>
      <b-row>
        <b-col md="12" class="d-flex ">

        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <b-form v-if="true" @submit.stop.prevent="handleSubmit(onSubmit)">
              <b-form-row>
                <b-col cols="12">
                  <validation-provider v-if="true" name="observaciones" :rules="{ required: true }" v-slot="validationContext">
                  <b-form-group id="inputObservaciones-group" label="Observaciones :" label-for="inputObservaciones">
                    <b-form-textarea
                      id="inputObservaciones"
                      v-model="inputObservaciones"
                      placeholder=""
                      rows="3"
                      max-rows="6"
                      :disabled="disabled"
                      :state="checkForm(validationContext)"
                    ></b-form-textarea>
                    </b-form-group>
                    <b-form-invalid-feedback id="inputCantidadDias-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </b-col>
              </b-form-row>
            <b-form-row>
              <b-col class="text-right">
                <b-button :disabled="disabled" class="mb-2" variant="warning" v-on:click="cerrarFormulario()">Cancelar</b-button>
                <b-button :disabled="disabled" class="mb-2" v-if="isInRoleAdmin || isInRoleCoordinador" type="submit" variant="warning">Agregar comentario</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'
import PersonalSvc from '@/services/personal'
import Solicitudsvc from '@/services/solicitudes'
import CardDatosContacto from '../../common/CardDatosContacto'
import ItemListaSolicitud from '../../common/ListaSolicitudItem'
import TablaCargoPersonal from '../../common/TablaCargoPersonal'



import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapFormSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "AgregarComentarioSolicitudForm",
  mixins: [errorhandler, swalerts],
  components: { CardDatosContacto, ItemListaSolicitud, TablaCargoPersonal },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'InputDni']),
    ...mapGetters(['getEstablecimiento','isInRoleAdmin','isInRoleCoordinador','isInRoleEstablecimiento','isInRoleRecMedico']),
    ...mapFormSolicitudFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado']),
  },
  props: {
    personal: Object,
    cargopersonal: Array
  },
  watch: {
  },
  data() {
    return {
      disabled: false,
      solicitud: null,
      inputObservaciones: null,
    };
  },
  watch: {
  },
  mounted(){
    this.solicitud = this.$route.params.solicitud;
    this.buscarPersonal();
  },
  methods: {
    ...mapActions("SolicitudModule", ["cambiarEstado"]),
    checkForm: function({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      console.log('onSubmit');
      this.agregarComentarioSolicitud(this.solicitud, this.getEstablecimiento);
    },
    buscarPersonal() {
      PersonalSvc.getPersonal({
        Id: this.solicitud.Personal_Id,
        IncluyeCargoPersonal: true,
        unidadeducativa_id: this.getEstablecimiento ? this.getEstablecimiento.UnidadEducativa_Id : 0,
        nivelenseñanza_id: this.getEstablecimiento ? this.getEstablecimiento.NivelEnseñanza_Id : 0
        }).then(response => {
          console.log('fin find personal', response);
          this.Personal = response.data.objeto;
          if (response.data.objeto.CargoPersonal.length > 0) {
            this.ListaCargoPersonal = response.data.objeto.CargoPersonal;
            this.ListaCargoPersonal = response.data.objeto.CargoPersonal;
          }

          this.disabled = false;
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          this.showWarning('No se encontró el personal asociado a esta solicitud.');
        } else {
          this.errorHandler(error);
        }
        console.log('error buscarPersonal', error);
      });
    },
    agregarComentarioSolicitud(item) {
      console.log('agregarComentarioSolicitud', item, this.getEstablecimiento, this.ListaCargoPersonalSeleccionado);
      var ajustarPaginacion = true;
      this.showConfirmarInfo('Confirmar', `La solicitud ${item.Id} | ${this.ListaCargoPersonalSeleccionado} será comentada.`, 'Agregar Comentario')
      .then((willChange) => {
        console.log('then willChange', willChange);
        if (willChange.isConfirmed) {
          let qryparams = {
              id: item.Id,
              observaciones: this.inputObservaciones,
              ListaCargoPersonal_Id: this.ListaCargoPersonalSeleccionado.slice(),
              estado: { value: 5, text: 'Recibido'},
              nivelenseñanza_id: this.getEstablecimiento.NivelEnseñanza_Id,
              unidadeducativa_id: this.getEstablecimiento.UnidadEducativa_Id,
              unidadadministrativa_id: this.getEstablecimiento.UnidadAdministrativa_Id,
          };
          this.cambiarEstado(qryparams)
            .then(response => {
              console.log('cambiarEstado then', response);
              this.showSuccess(response.data.status.mensaje);
              this.$router.push({ name: 'consultasolicitud', params: {  } });
            })
            .catch(error => {
              this.errorHandler(e);
            });
        }
      });
    },
    cerrarFormulario(mensaje){
      this.limpiarFormulario();
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$router.push({ name: 'consultasolicitud', params: {  } });
    },
    limpiarFormulario()
    {
      this.ListaCargoPersonalSeleccionado = [];
    },
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/AgregarComentarioSolicitudForm.vue